import { forwardRef } from 'react';

import V1 from './v1';
import V2 from './v2';

const ReactSelectUsers = forwardRef(
  ({ designSystemStyle, ...otherProps }, ref) =>
    designSystemStyle ? (
      <V2 {...otherProps} ref={ref} />
    ) : (
      <V1 {...otherProps} ref={ref} />
    ),
);

export default ReactSelectUsers;
